import styled from "styled-components";

export const PageLayout = styled.div`
  background-color: var(--color-white1);
  height: calc(100% - 100px);
  overflow-y: auto;
`;
